import React from 'react';
import QuestionsColumn from './QuestionsColumn';
import PhaseColumn from './PhaseColumn';
import {ProgramAverageColumn} from './AverageColumn';

export default function AnalyticsGrid({
  reportAnalyticsObj,
  displayedQuestions,
  compact,
  openedDay,
  reportType,
  enablePtoAnalytics,
  isApproveReportsLoading,
  popupPosition,
  getPhases,
  getWeeks,
  getDays,
  getLogGroupLabel,
  getSequenceNumber,
  getLogGroup,
  getBackgroundColor,
  getCellColor,
  getCellValue,
  renderCommentPopup,
  getAvgPerDay,
  getAvgCellValue,
  getAvgBackgroundColor,
  getTotalTimeSpend,
  getPhaseTotalTimeSpend,
  getProgramTotalTimeSpend,
  timeConvert,
  openDay,
  openApproveReports,
  renderReportsState,
  setPopupPosition,
  closeOpenedDay,
}) {
  const reportAnalytics = reportAnalyticsObj.reportAnalytics;
  const openedDayReports = openedDay
    ? reportAnalytics.reportMap[`${openedDay.phaseGuid}${openedDay.week}${openedDay.day}`]
    : null;

  return (
    <div className="analytics-report">
      <QuestionsColumn
        displayedQuestions={displayedQuestions}
        openedDay={openedDay}
        logGroupLabel={openedDayReports ? getLogGroupLabel(openedDayReports) : 'N/A'}
      />
      <div className="phases">
        {getPhases(reportAnalytics.phases, reportAnalyticsObj.user.guid).map(phase => (
          <PhaseColumn
            key={phase.guid}
            reportAnalytics={reportAnalytics}
            phase={phase}
            displayedQuestions={displayedQuestions}
            compact={compact}
            openedDay={openedDay}
            reportType={reportType}
            enablePtoAnalytics={enablePtoAnalytics}
            isApproveReportsLoading={isApproveReportsLoading}
            popupPosition={popupPosition}
            getWeeks={getWeeks}
            getDays={getDays}
            openDay={openDay}
            openApproveReports={openApproveReports}
            renderReportsState={renderReportsState}
            setPopupPosition={setPopupPosition}
            getSequenceNumber={getSequenceNumber}
            getLogGroup={getLogGroup}
            getBackgroundColor={getBackgroundColor}
            getCellColor={getCellColor}
            getCellValue={getCellValue}
            renderCommentPopup={renderCommentPopup}
            getAvgPerDay={getAvgPerDay}
            closeOpenedDay={closeOpenedDay}
            getAvgCellValue={getAvgCellValue}
            getAvgBackgroundColor={getAvgBackgroundColor}
            getTotalTimeSpend={getTotalTimeSpend}
            getPhaseTotalTimeSpend={getPhaseTotalTimeSpend}
            timeConvert={timeConvert}
          />
        ))}
        {!enablePtoAnalytics && (
          <ProgramAverageColumn
            reportAnalytics={reportAnalytics}
            displayedQuestions={displayedQuestions}
            reportType={reportType}
            openedDay={openedDay}
            getAvgCellValue={getAvgCellValue}
            getProgramTotalTimeSpend={getProgramTotalTimeSpend}
            timeConvert={timeConvert}
          />
        )}
      </div>
    </div>
  )
}
